// Mock data for Elvis One More Time landing page

export const testimonials = [
  {
    id: 1,
    text: "His natural connection with the audience is amazing!....He has the audience captivated!",
    author: "Charles Stone",
    role: "Elvis' Tour Director 1970 - 1977",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/xacvgtcp_Charles%20Stone.jpg"
  },
  {
    id: 2,
    text: "I enjoyed listening to Gary, he does a fantastic job",
    author: "DJ Fontana",
    role: "Elvis' Drummer 1955 - 1968",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/o8mk3p4a_DJ%20Fontana.jpg"
  },
  {
    id: 3,
    text: "Gary will certainly bring back some wonderful memories of Elvis",
    author: "Sonny West",
    role: "Member of The Memphis Mafia 1960 - 1976",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/a2chgdri_sonnywest_2017_05_25.jpg"
  },
  {
    id: 4,
    text: "The same attention to details that I saw in every performance Elvis ever did",
    author: "Dick Grob",
    role: "Elvis' Bodyguard and Head of Security 1967 - 1977",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/8w73j943_Dick%20Grob.jpg"
  },
  {
    id: 5,
    text: "Absolutely superb! Everyone is still talking about it!",
    author: "The Royal British Navy",
    role: "",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/rzp5eb3i_Royal%20Navy%20Logo.png",
    isLogo: true
  },
  {
    id: 6,
    text: "The King",
    author: "ITV Anglia Television",
    role: "Anglia",
    rating: 5,
    image: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/u7tx6hf7_Anglia%20TV%20Logo.png",
    isLogo: true
  }
];

export const benefits = [
  {
    id: 1,
    title: "Authentic Las Vegas Vibes",
    description: "Recreating the magic of Elvis' legendary Vegas Concerts, Gary pays meticulous attention to every detail, from replica costumes and jewellery to digitised backing tracks endorsed by Elvis' own band. With cutting-edge sound and lighting, his act flawlessly fuses nostalgia and modern showmanship."
  },
  {
    id: 2,
    title: "Emotional Connection That Lasts",
    description: "The key to a standout event is creating an emotional chord with your audience, and Gary's show does exactly that. His naturally warm stage presence and accurate vocals evoke the timeless essence of Elvis, leaving guests talking about your event, long after the curtain has fallen."
  },
  {
    id: 3,
    title: "Officially Endorsed Excellence",
    description: "Backed by Elvis's own tour director, drummer, and bodyguard, plus brands like ITV, BBC, Hilton & Guinness World Records, Gary brings rock-solid credibility to your event."
  },
  {
    id: 4,
    title: "Genuine Las Vegas Spectacle",
    description: "Replica jumpsuits, digitised backing tracks approved by Elvis's band, and state-of-the-art sound and lighting recreate the magic of the King's legendary Vegas shows."
  },
  {
    id: 5,
    title: "Live Band Option",
    description: "Gary is also available backed by his superb 5/6 piece band Graceland2Vegas featuring some of the finest session musicians in the industry!"
  },
  {
    id: 6,
    title: "Hassle-Free Professionalism",
    description: "From punctual load-in to seamless tech checks, Gary handles the details, letting you focus on guests rather than logistics."
  },
  {
    id: 7,
    title: "Premium Entertainment, Clear Pricing",
    description: "The quoted fee covers the full Vegas-style experience, delivering top-tier value without hidden add-ons."
  }
];

export const faqData = [
  {
    id: 1,
    question: "How long is the show?",
    answer: "The show is available in two formats, one 60-minute set or two 45-minute sets, whichever best suits your event. For theatre settings, two 60-minute sets are also available."
  },
  {
    id: 2,
    question: "What is included in the show fee?",
    answer: "The fee includes Gary's Vegas-style performance, authentic costumes, professional sound and lighting, with UK travel expenses included for most bookings. Accommodation is also included where required and agreed in advance."
  },
  {
    id: 3,
    question: "How far in advance should the show be booked?",
    answer: "We recommend booking at least 8 to 12 weeks in advance, especially for weekend dates and during peak seasons. However, shorter notice bookings can sometimes be accommodated, depending on availability."
  },
  {
    id: 4,
    question: "How does booking and payment work?",
    answer: "Bookings are secured through our online booking system. A 20% deposit is required at the time of booking, with the remaining balance due two days prior to the event."
  },
  {
    id: 5,
    question: "Can Elvis's appearance be kept a surprise for our guests?",
    answer: "Absolutely. We understand how important it is to keep the surprise under wraps. We can coordinate with you discreetly and complete set-up before your guests' arrival, so everything remains a surprise until the moment Gary takes the stage."
  },
  {
    id: 6,
    question: "What are the technical requirements for the show?",
    answer: "Gary provides his own professional sound system and lighting. All that is required is access to power through a standard power outlet, along with sufficient space for the performance. The system is highly flexible and can be adapted to suit the venue. Detailed technical specifications can be provided upon booking."
  },
  {
    id: 7,
    question: "Is the show suitable for different venues and events?",
    answer: "Yes, the show is suitable for a wide variety of venues and occasions. The performance can be tailored to suit any setting, from home to theatre, including corporate functions, weddings, private parties, and public events."
  },
  {
    id: 8,
    question: "How much set-up time does the show require?",
    answer: "Set-up, including sound-check, can usually be completed within 60 minutes. This may vary depending on the venue and performance format, but all arrangements will be discussed in advance to ensure everything runs smoothly on the day. Gary works efficiently and discreetly to keep the process as simple as possible for your event."
  },
  {
    id: 9,
    question: "What is the cancellation or rescheduling policy?",
    answer: "If you need to cancel or reschedule your booking, please get in touch as soon as possible. Any changes are handled as fairly and flexibly as possible, depending on the notice given and the circumstances. Please note that the 20% deposit is non-refundable in the event of cancellation by the client. If a booking is rescheduled, the deposit can be transferred to the new date. Full details of the cancellation and rescheduling policy can be provided at the time of booking."
  },
  {
    id: 10,
    question: "Is the show available outside the UK?",
    answer: "Yes, international bookings can be arranged depending on the location, venue, and travel requirements. Gary has previously performed in Bahrain, the UAE, Spain, Germany, and Cyprus. Overseas travel and accommodation are quoted separately. Please get in touch with your event details and we will be happy to discuss availability and provide a tailored quote."
  }
];

export const galleryImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/zkazflhm_Gary%20Jay%201.JPG",
    alt: "Gary Jay performing in white Elvis jumpsuit with band",
    caption: "Live with the band"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/z765ozfl_Gary%20Jay%202.jpg",
    alt: "Gary Jay performing in black leather with crowd",
    caption: "Engaging the audience"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/4pt98vm0_Gary%20Jay%203.jpg",
    alt: "Gary Jay in iconic white jumpsuit pointing to crowd",
    caption: "The Vegas experience"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/9h3wuuxy_Gary%20Jay%203a.JPG",
    alt: "Gary Jay performing with full band on stage",
    caption: "Full band performance"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/yybm045v_Gary%20Jay%204.jpg",
    alt: "Gary Jay entertaining guests at wedding reception",
    caption: "Wedding entertainment"
  },
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/els9oub7_Gary%20Jay%204A.JPG",
    alt: "Gary Jay performing duet on stage",
    caption: "Special guest performance"
  },
  {
    id: 7,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/ko7339ii_Gary%20Jay%205.JPG",
    alt: "Gary Jay with full band including drums",
    caption: "The full band experience"
  },
  {
    id: 8,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/k3mdac5l_Gary%20Jay%206.jpg",
    alt: "Gary Jay with celebrity guests at special event",
    caption: "Celebrity appearances"
  },
  {
    id: 9,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/b6p47r1e_Gary%20Jay%207.jpg",
    alt: "Gary Jay in white jumpsuit performing with band",
    caption: "Stage presence"
  },
  {
    id: 10,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/jo6e9sso_Gary%20Jay%207A.JPG",
    alt: "Gary Jay on stage with special guest",
    caption: "Theatre performances"
  },
  {
    id: 11,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/yku2qb38_Gary%20Jay%208.jpg",
    alt: "Gary Jay with showgirls in front of Las Vegas sign",
    caption: "Vegas showgirl experience"
  },
  {
    id: 12,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/c59zvnuu_Gary%20Jay%208A.jpg",
    alt: "Gary Jay performing at outdoor garden party for children",
    caption: "Family entertainment"
  },
  {
    id: 13,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/m8tjxvrg_Gary%20Jay%209.jpg",
    alt: "Gary Jay performing Elvis One More Time show with full band",
    caption: "The Elvis One More Time show"
  },
  {
    id: 14,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/fuesbn09_Gary%20Jay%209A.jpg",
    alt: "Gary Jay performing at unique venue with crystal chandelier",
    caption: "Unique venue performances"
  },
  {
    id: 15,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/wyyhtw42_Gary%20Jay%2010.jpg",
    alt: "Gary Jay with wedding party and confetti",
    caption: "Vegas-style weddings"
  },
  {
    id: 16,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/5ymbji77_Gary%20Jay%2010A.jpg",
    alt: "Gary Jay in embroidered eagle jumpsuit with purple lighting",
    caption: "Iconic eagle jumpsuit"
  },
  {
    id: 17,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/ku9uxjdo_Gary%20Jay%2011.jpg",
    alt: "Gary Jay performing with band and Elvis One More Time backdrop",
    caption: "The One More Time show"
  },
  {
    id: 18,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/q6zsmikt_Gary%20Jay%2012.jpg",
    alt: "Gary Jay performing at outdoor pergola wedding venue",
    caption: "Outdoor wedding performances"
  },
  {
    id: 19,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/qzdkonf8_Gary%20Jay%2012A.jpg",
    alt: "Gary Jay with Dancing On Ice cast members",
    caption: "Dancing On Ice appearance"
  },
  {
    id: 20,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/ga1bh57m_Gary%20Jay%2012B.JPEG",
    alt: "Gary Jay with Elvis's inner circle members",
    caption: "With Elvis's inner circle"
  },
  {
    id: 21,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/ha84wtzc_Gary%20Jay%2013.jpg",
    alt: "Gary Jay connecting with fans reaching out from stage",
    caption: "Connecting with fans"
  },
  {
    id: 22,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/u525q2yc_Gary%20Jay%2014.jpg",
    alt: "Gary Jay officiating wedding ceremony in white jumpsuit",
    caption: "Wedding ceremonies"
  },
  {
    id: 23,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/lgc6vrat_Gary%20Jay%2015.JPG",
    alt: "Gary Jay performing signature Elvis move in eagle jumpsuit",
    caption: "Signature Elvis moves"
  },
  {
    id: 24,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/gvv6vt29_Gary%20Jay%2016.jpg",
    alt: "Gary Jay serenading newlyweds at theatre wedding",
    caption: "Theatre wedding celebrations"
  },
  {
    id: 25,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/78g0497s_Gary%20Jay%2017.JPG",
    alt: "",
    caption: ""
  },
  {
    id: 27,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/iwayhpkd_Gary%20Jay%2018.jpg",
    alt: "",
    caption: ""
  },
  {
    id: 28,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/7ojotfya_Gary%20Jay%2019.jpg",
    alt: "Gary Jay on Dancing On Ice with professional skaters",
    caption: "Dancing On Ice performance"
  },
  {
    id: 29,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/0crzn49z_Gary%20Jay%2020A.jpg",
    alt: "Gary Jay in blue jumpsuit at luxury hotel event",
    caption: "Luxury hotel events"
  },
  {
    id: 30,
    src: "https://customer-assets.emergentagent.com/job_ed1b1c0e-3d9a-4db5-9b20-6722745ae939/artifacts/lrknibhu_Gary%20Jay%2021.JPG",
    alt: "Gary Jay in blue jumpsuit meeting guests",
    caption: "Meet and greet"
  }
];

export const showFeatures = [
  "1 x 60 minutes or 2 x 45 minutes performance",
  "68 Comeback black leather or Vegas jumpsuits",
  "Premium backing tracks or live band options",
  "Optional DJ set and first dance performance",
  "Bespoke song arrangements available",
  "Meet and greet photo opportunities",
  "Self-contained PA and lighting system",
  "Quick setup with minimal venue disruption",
  "Full public liability insurance",
  "PAT tested equipment with certificates"
];

export const trustMarkers = [
  "Endorsed by Elvis's inner circle",
  "International bookings available",
  "Fully insured and PAT tested"
];

// Mock blocked dates for calendar (dates that are already booked)
export const blockedDates = [
  new Date(2025, 7, 15), // August 15, 2025
  new Date(2025, 7, 22), // August 22, 2025
  new Date(2025, 8, 5),  // September 5, 2025
  new Date(2025, 8, 12), // September 12, 2025
];
